import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-14 md:py-16 bg-[#111827]" data-id="element-66">
      <div className="max-w-[980px] mx-auto px-4" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="border border-[#f5a623]/30 bg-[#1a1f35] rounded-2xl p-6 md:p-10 text-center relative overflow-hidden max-w-2xl mx-auto" data-id="element-68">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-transparent via-[#f5a623] to-transparent opacity-50" data-id="element-69" />

          <div className="flex justify-center mb-5" data-id="element-70">
            <ShieldCheck className="w-16 h-16 text-[#f5a623]" data-id="element-71" />
          </div>

          <h2 className="text-[24px] md:text-[32px] font-black text-white mb-4 uppercase" data-id="element-72">
            Garantía sin vueltas
          </h2>

          <p className="text-[17px] text-gray-300 mb-3 leading-relaxed" data-id="element-73">
            Estamos tan seguros de que este programa te va a encantar, que si no
            es así, te devolvemos el 100% de tu dinero.
          </p>

          <p className="text-[17px] text-gray-400" data-id="element-74">
            Tenés 7 días para probarlo sin riesgo. Si no te convence, nos
            escribís y te hacemos el reembolso. Así de simple.
          </p>
        </motion.div>
      </div>
    </section>;
}